import { useMeQuery, useUserQuery } from '../../../generated/graphql';

import { Formik } from 'formik';
import { GroupSelector } from '../../RegistrationScreen/components/GroupSelector';
import React from 'react';
import styles from './MyGroup.module.css';

interface MyGroupProps {}

export const MyGroup: React.FC<MyGroupProps> = () => {
    const me = useMeQuery();
    const userId = me.data?.me?.id;
    const user = useUserQuery({ variables: { id: userId || '' }, skip: !userId });

    const handleSubmit = (values: { group?: string }) => {
        // Group selection is handled by the GroupSelector component
        console.log('Group selected:', values.group);
    };

    return (
        <div className={styles.groupContainer}>
            {/* <label className={styles.groupLabel}>Ваша група:</label> */}
            <Formik initialValues={{}} onSubmit={handleSubmit}>
                <GroupSelector isStudent={false} />
            </Formik>
        </div>
    );
};
